export default function formatArea(areaUnit, area) {
  let t = !!area && Number(area) > 0 ? area : null;
  if (!t) return t;

  t = t.toLocaleString("pt-BR", {
    maximumFractionDigits: 2,
  });

  const types = {
    alqueire: "alq",
    hectare: "ha",
    metros: "m²",
  };

  const formatUnit = types[areaUnit] || null;

  return t + (formatUnit ? ` ${formatUnit}` : "");
}
